import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { LegalPageLayout } from '../components/LegalPageLayout';
import { SiteHeader } from '../components/SiteHeader';
import { AppFooter } from '../components/AppFooter';
import { useScreenInit } from '../useScreenInit';
export function MedicalDisclaimer() {
  useScreenInit('MedicalDisclaimer');
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-1068">
      <Helmet data-id="element-1069">
        <title data-id="element-1070">Medical Disclaimer | Affordable Medical Tourism</title>
        <meta name="description" content="Important medical disclaimer regarding the services provided by affordablemedicaltourism.com." data-id="element-1071" />
      </Helmet>

      <SiteHeader brand="Affordable Medical Tourism" links={[{
      label: 'Procedures',
      href: '/procedures'
    }, {
      label: 'How it works',
      href: '/how-it-works'
    }, {
      label: 'Destinations',
      href: '/destinations'
    }, {
      label: 'FAQ',
      href: '/faq'
    }]} contactCtaLabel="Get a free quote" onContactCta={() => navigate('/contact')} data-id="element-1072" />

      <main className="flex-1" data-id="element-1073">
        <LegalPageLayout title="Medical Disclaimer" lastUpdated="October 15, 2023" illustrative={true} intro={<p className="text-lg text-slate-600 mb-8" data-id="element-1075">
              The information provided by affordablemedicaltourism.com, a
              product of Kosansh Solutions Inc., is for general informational
              and educational purposes only. It is not a substitute for
              professional medical advice, diagnosis, or treatment.
            </p>} sections={[{
        id: 'not-medical-advice',
        heading: '1. Not Medical Advice',
        body: <div className="space-y-4 text-slate-600" data-id="element-1076">
                  <p data-id="element-1077">
                    Kosansh Solutions Inc. is a medical tourism facilitation and
                    coordination service. We are not a hospital, clinic, or
                    healthcare provider. We do not employ physicians, and we do
                    not provide medical consultations, diagnoses, or treatments.
                  </p>
                  <p data-id="element-1078">
                    Any information found on this website, including text,
                    graphics, images, and statistics regarding procedures,
                    savings, or destinations, is intended to assist you in
                    making informed decisions but should never replace a
                    consultation with a qualified healthcare professional.
                    Always seek the advice of your physician or other qualified
                    health provider with any questions you may have regarding a
                    medical condition.
                  </p>
                </div>
      }, {
        id: 'illustrative-data',
        heading: '2. Illustrative Data and Statistics',
        body: <div className="space-y-4 text-slate-600" data-id="element-1079">
                  <p data-id="element-1080">
                    Throughout our website, we may present statistics regarding
                    potential cost savings, patient volumes, or hospital
                    accreditations (e.g., "Save up to 70%," "10,000+ patients").
                    Unless explicitly cited from a verified third-party report,
                    these figures are illustrative estimates based on broad
                    industry averages and historical data.
                  </p>
                  <p data-id="element-1081">
                    Actual costs, savings, and outcomes vary significantly based
                    on individual medical needs, the specific facility chosen,
                    currency fluctuations, and unforeseen complications. You
                    will receive a personalized, formal quote directly from the
                    healthcare provider before committing to any procedure.
                  </p>
                </div>
      }, {
        id: 'provider-vetting',
        heading: '3. Third-Party Healthcare Providers',
        body: <div className="space-y-4 text-slate-600" data-id="element-1082">
                  <p data-id="element-1083">
                    While we strive to partner exclusively with internationally
                    accredited facilities (such as those accredited by the Joint
                    Commission International), Kosansh Solutions Inc. does not
                    guarantee the quality of care, medical outcomes, or safety
                    of any third-party provider.
                  </p>
                  <p data-id="element-1084">
                    The decision to undergo medical treatment abroad carries
                    inherent risks, including but not limited to travel-related
                    complications, differences in legal and malpractice
                    frameworks, and varying standards of care. It is your sole
                    responsibility to research the credentials of the specific
                    physician and facility recommended to you.
                  </p>
                </div>
      }, {
        id: 'emergencies',
        heading: '4. Medical Emergencies',
        body: <div className="space-y-4 text-slate-600" data-id="element-1085">
                  <p data-id="element-1086">
                    If you think you may have a medical emergency, call your
                    doctor, go to the nearest hospital emergency department, or
                    call emergency services immediately. Do not rely on
                    electronic communications or communication through this
                    website for immediate, urgent medical needs.
                  </p>
                </div>
      }]} data-id="element-1074" />
      </main>

      <AppFooter data-id="element-1087" />
    </div>;
}